/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class RecommendLinkPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(recommendLinkPopup, linkEditDetails) {
    recommendLinkPopup.setAttribute(
      'univ-semantic-name',
      this.pathQueryMap.pathMap.univ
    );

    recommendLinkPopup.setAttribute('source-type', linkEditDetails.sourceType);

    if (recommendLinkPopup._link && recommendLinkPopup._link.semanticName)
      recommendLinkPopup.setAttribute(
        'semantic-name',
        recommendLinkPopup._link.semanticName
      );
    else recommendLinkPopup.setAttribute('semantic-name', '');
  }
}
